import React from "react";
import moment from "moment";
import { useApplication } from "../../contexts/ApplicationContext";

const HeaderQuery = ({
  title,
  type = "default",
  hasHeader = true,
  date = "",
  document = "",
  hasRestrictions = null,
  logoURL = "",
  protocol = null,
}) => {
  const { user } = useApplication();

  let logoSrc;

  switch (true) {
    case window.location.href.includes("datacredi"):
      logoSrc = "/assets/white-label/data-credi/logo_branco.png";
      break;
    case window.location.href.includes("nexusid"):
      logoSrc = "/assets/white-label/nexus-id/logo_branco.png";
      break;
    case window.location.href.includes("crediavalia"):
      logoSrc = "/assets/white-label/credi-avalia/logo_branco.png";
      break;
    default:
      logoSrc = "/assets/white-label/nexus-id/logo_branco.png";
      break;
  }

  return (
    <>
      {hasHeader && (
        <>
          <div
            className={`flex flex-row justify-between text-end gap-2 mb-1 items-center`}
          >
            <div>
              {user?.Company?.showLogo && (
                <img src={logoSrc} className="w-40 mb-4" />
              )}
            </div>

            <div className="flex gap-1 items-center">
              <div className="flex gap-2 items-end">
                {logoURL && <img className="w-14" src={logoURL} />}
                <div className="flex flex-col gap-1">
                  <div className="font-semibold text-2xl">{title}</div>
                  <div className="italic text-sm">
                    {date && (
                      <span>
                        <b className="font-semibold">Data:</b> {date}
                      </span>
                    )}
                    {protocol && (
                      <span className="inline-block ml-4">
                        <b className="font-semibold">Protocolo:</b> {protocol}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HeaderQuery;
